<template>
	<div v-if="env != 'zfb'" class="img_account">
		<img src="@/assets/image/account_code.jpg" alt="" />
		<div class="mt_2">长按识别二维码关注公众号，查询下载保单</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			env: '',
		};
	},
	created() {
		this.env = this.$base.getEnv();
	},
};
</script>

<style lang="scss" scoped>
.img_account {
	font-size: 0.26rem;
	display: flex;
	justify-content: center;
	flex-direction: column;
	align-items: center;
	margin-top: 0.4rem;
	img {
		width: 4rem;
		height: 4rem;
	}

	.mt_2 {
		margin-top: 0.1rem;
	}
}
</style>
